'use client';
import styles from './accessibility-link.module.scss';
import AccessibilityIcon from 'assets/icons/accessibility.svg';
import DownArrow from 'assets/icons/arrows/down-arrow.svg';
import { Link } from 'src/navigation';

const AccessibilityLink = () => {
	return (
		<>
			<span
				className={styles.iconContainer}
				style={{ gridColumn: 1, gridRow: 4 }}
			>
				<AccessibilityIcon style={{ width: '25px', height: 'auto' }} />
			</span>
			<span style={{ gridColumn: 2, gridRow: 4 }}>
				<Link
					href="#accessibility"
					onClick={(event) => {
						event.preventDefault();
						document
							.getElementById('accessibility')
							.scrollIntoView({ behavior: 'smooth' });
					}}
				>
					Accessibility information
				</Link>
				&nbsp;
				<div className={styles.downArrowContainer}>
					<DownArrow />
				</div>
			</span>
		</>
	);
};

export default AccessibilityLink;
